import React from "react";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { IPaginationProps } from "../types";
import { useTranslation } from 'react-i18next';

const Pagination = ({ currentPage, totalPages, paginateNext, paginatePrev, hasMore, hasPrev }: IPaginationProps) => {
  const { t } = useTranslation();
  const tBase = "views.duplicates.customers.components.Pagination";
  const tr = (key: string) => t(`${tBase}.${key}`);

  return (
    <div className="fixed bottom-0 w-[calc(100%-32px)] w- h-16 bg-white border-t border-gray-300 flex items-center ">
      <div className="flex justify-center items-center gap-2 w-[500px]">
        <button 
          disabled={!hasPrev} 
          onClick={paginatePrev}
          className={`
            px-3 ml-auto h-10 flex items-center justify-center rounded-[4px] font-bold text-sm no-underline hover:bg-gray-100
            ${!hasPrev ? 
              "text-gray-400 hover:text-gray-500  cursor-not-allowed" 
              : "text-primary cursor-pointer"
            } 
            transition-colors duration-300 ease-in-out
          `}
        >
          <IoIosArrowBack />
          {tr("Previous")}
        </button>

        <div className="px-4 text-sm text-gray-600">
          Page {currentPage} of {totalPages}
        </div>

        <button 
          disabled={!hasMore} 
          onClick={paginateNext}
          className={`
          px-3 ml-auto h-10 flex items-center justify-center rounded-[4px] font-bold text-sm no-underline hover:bg-gray-100
          ${!hasMore ? 
            "text-gray-400 hover:text-gray-500  cursor-not-allowed" 
            : "text-primary cursor-pointer"
          } 
          transition-colors duration-300 ease-in-out
          `}
        >
          {tr("Next")}
          <IoIosArrowForward />
        </button>
      </div>
    </div>

  );
};

export default Pagination;
